import { Box, CircularProgress, Typography } from '@mui/material'
import PropTypes from 'prop-types'

/**
 * Reusable loading state component
 * @param {Object} props
 * @param {string} props.message - Optional loading message
 * @param {number} props.height - Height of the loading container (default: 400)
 * @param {string} props.size - Size of the CircularProgress (default: 'large')
 */
export function LoadingState({ message, height = 400, size = 'large' }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height,
        gap: 2,
      }}
    >
      <CircularProgress size={size === 'large' ? 40 : size === 'small' ? 24 : 32} />
      {message && (
        <Typography variant='body1' color='text.secondary' align='center'>
          {message}
        </Typography>
      )}
    </Box>
  )
}

LoadingState.propTypes = {
  message: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  size: PropTypes.oneOf(['small', 'medium', 'large']),
}
